/**
 * Inspire-hub 2 (www.giap.pl)
 *
 * Copyright © GIAP sp.z.o.o. All rights reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Krzysztof Gregorowicz <gregorowicz.k@gmail.com>, February 2017
 */
/* flow-disable */

import React, { PropTypes } from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import GrayPanel from '../../../components/GrayPanel';
import s from './Claims.css';


class Claims extends React.Component {
  static propTypes = {
    title: PropTypes.string.isRequired,
  };

  render() {
    return (
      <div>Claims</div>
    )
  }
}

export default withStyles(s)(Claims);


// WEBPACK FOOTER //
// src/routes/admin/claims/Claims.js